import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { fdAppShowcase } from "../fdModulesData";
import FdImagePlaceholder from "./FdImagePlaceholder";

const FdAppShowcaseSection: React.FC = () => {
  return (
    <section className="wdev-process" aria-labelledby="fd-showcase-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2
            id="fd-showcase-title"
            className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
          >
            App Screens &amp; Features
          </h2>
          <p className="fd-section-lead fd-section-lead--dark">
            Intuitive interfaces for browsing menus, searching restaurants, filtering offers, and
            discovering food near you.
          </p>
        </AnimatedSection>

        <div className="fd-showcase-grid">
          {fdAppShowcase.map((item, index) => (
            <motion.article
              key={item.title}
              className="wdev-process__card fd-showcase-card"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -4, transition: { duration: 0.25 } }}
            >
              <FdImagePlaceholder
                variant="screen"
                label={item.placeholderLabel}
                hint={item.placeholderHint}
                className="fd-showcase-card__placeholder"
              />
              <h3 className="wdev-process__title">{item.title}</h3>
              <p className="wdev-process__desc">{item.description}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FdAppShowcaseSection;
